'use client'

import NumberInput from '@/components/design-system/number-input'
import PercentIcon from '@/components/icons/percent'
import { Flex } from '@/styled-system/jsx'
import { memo, type CSSProperties } from 'react'
import Profit from './profit'

export type OddsTableProps = {
  profit: number
  chance: number
  arrowPosition: string
  isVisible: boolean
}

const OddsTable = memo(function OddsTable({
  profit,
  chance,
  arrowPosition,
  isVisible,
}: OddsTableProps) {
  return (
    <Flex
      position='absolute'
      bottom='calc(100% + 1em)'
      right={0}
      w='full'
      p='1em'
      gap={4}
      bg='neutral.200'
      borderRadius='sm'
      boxShadow='md'
      css={{
        '& > *': {
          flex: '1 1 0',
        },
      }}
      _after={{
        content: '""',
        position: 'absolute',
        top: '100%',
        left: 'var(--arrow-position)',
        borderStyle: 'solid',
        borderWidth: '0.5em 0.5em 0',
        borderColor: 'transparent',
        borderTopColor: 'neutral.200',
        transform: 'translate(-50%)',
      }}
      style={
        {
          opacity: isVisible ? 1 : 0,
          '--arrow-position': arrowPosition,
        } as CSSProperties
      }
    >
      <Profit value={profit} />

      <NumberInput
        size='lg'
        label='Chance'
        value={chance * 100}
        decimalScale={4}
        readOnly
        endAdornment={<PercentIcon color='text.secondary' />}
      />
    </Flex>
  )
})

export default OddsTable
